import styled from '@emotion/styled/macro';
import { colors } from '../../../../common/styles/theme.styles';

export const ControlsBar = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff;
  border-radius: 40px;
  box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.05);
  padding: 4px 12px;
`;

export const ControlButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: none;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease;
  
  &:hover {
    background: ${colors.lightGray2};
  }
  
  &:active {
    background: ${colors.lightGray2};
  }
`;

export const ControlsDivider = styled.div`
  width: 1px;
  height: 24px;
  background: #DDE3EB;
`; 